import { DateInputHTMLElement } from "components/input/baseHTMLElementDateInput";
import { Tooltip } from "components/components/tooltip/tooltip";
import i18n from "components/i18n/i18n";
import sislogUserGlobals from "components/UserGlobals";
import { EnumDateInputType } from "components/input/dateFormats";
import moment from "moment";
import template from "./dateTimeInput.hbs";
import { IMaskDateblocks, getMinDateIMask, getMaxDateIMask } from "components/input/imaskDateBlocks";

export class DateTimeInputElement extends DateInputHTMLElement {

  constructor() {
    super();

    const optTemplate = {
      "prefixId": "dti",
      "id": this.getAttribute("_id"),
      "className": "c-datetime-input__input o-form-component__input o-form-component__input-group__input",
      "disableFocusKeyboard": (this.getAttribute("disableFocusKeyboard") === 'true'),
    } as any;
    this.innerHTML = template(optTemplate);

    this.input = this.querySelector("input");
    this.clearButton = this.querySelector(".c-datetime-input__clear");
    this.calendarIcon = this.querySelector("s6-date-calendar-icon");

    this.bindEvents();
    Tooltip.bindElement(this);
  }

  public isEqualToInitialValue(value: any): boolean {
    let isEqual: boolean = true;
    const initialValue = this.initialValue.value;

    isEqual = this.isEqualForDate(value, initialValue, 'seconds');

    return isEqual;
  }

  public defineDateRangePickerOptions(): any {

    if (this.dateRangePickerOptions == null) {
      const locale = i18n.instance.getResource(sislogUserGlobals.language, "translation", "daterangepicker.locale");
      this.dateRangePickerOptions = {
        autoApply: true,
        autoUpdateInput: false,
        alwaysShowCalendars: true,
        singleDatePicker: true,
        timePicker: true,
        timePicker24Hour: true,
        timePickerSeconds: true,
        showDropdowns: true,
        locale: {
          ...locale,
          format: EnumDateInputType.getFormatterPattern(EnumDateInputType.dateTime)
        },
        ranges: this.createRangesCalendar(),
        minYear: IMaskDateblocks.YYYY.from,
        maxYear: IMaskDateblocks.YYYY.to,
        minDate: getMinDateIMask(),
        maxDate: getMaxDateIMask(),
      };

      this.addDateRangePickerOptionIsInvalidDate();
    }
  }

  public defineIMaskOptions(): any {
    if (this.maskOptions == null) {
      const momentFormat = EnumDateInputType.getFormatterPattern(EnumDateInputType.dateTime);
      this.maskOptions = {
        mask: Date,
        pattern: momentFormat,
        lazy: false,
        format(date): string {
          return moment(date).format(momentFormat);
        },
        parse(str): Date {
          return moment(str, momentFormat).toDate();
        },
        blocks: IMaskDateblocks,
        min: getMinDateIMask(),
        max: getMaxDateIMask(),
      };
    }
  }

  public createRangesCalendar() {
    let ranges = {};
    ranges[i18n.instance.t("daterangepicker.range.today")] = [moment(), moment()];
    ranges[i18n.instance.t("daterangepicker.range.yesterday")] =
      [moment().subtract(1, "days"), moment().subtract(1, "days")];
    ranges[i18n.instance.t("daterangepicker.range.tomorrow")] =
      [moment().add(1, "days"), moment().add(1, "days")];

    return ranges;
  }

  public getFormat(): Intl.DateTimeFormat {
    return EnumDateInputType.getIntlDateTimeFormat(EnumDateInputType.dateTime);
  }

  get data(): Date {
    let tzDate = this.input.value as string;
    if (tzDate) {
      const date = moment.utc(tzDate, EnumDateInputType.getFormatterPattern(EnumDateInputType.dateTime));
      if (date.isValid()) {
        if (date.year() < IMaskDateblocks.YYYY.from) {
          date.year(IMaskDateblocks.YYYY.from);
        }
        if (date.year() > IMaskDateblocks.YYYY.to) {
          date.year(IMaskDateblocks.YYYY.to);
        }
        return date.toDate();
      }
    } else {
      this.resetDatePicker();
    }
    return null;
  }

  set data(v: Date) {
    this.input.value = this.doFormatDate(v) ?? null;
    this.initialValue.value = this.data;
    this.mask?.updateValue();
    this.setClearButtonVisibility();
  }

}

export function initDateTimeInputWebComponent() {
  window.customElements.define("s6-date-time-input", DateTimeInputElement);
}
